import React from "react";
import { Lock } from "lucide-react";

const VisaLogo = () => (
  <svg viewBox="0 0 48 16" width="46" height="15" role="img" aria-label="Visa" className="shrink-0">
    <text x="0" y="13" fontFamily="Arial, Helvetica, sans-serif" fontSize="15" fontWeight="700" fontStyle="italic" fill="#1A1F71" letterSpacing="0.5">VISA</text>
  </svg>
);

const MastercardLogo = () => (
  <svg viewBox="0 0 36 24" width="34" height="22" role="img" aria-label="Mastercard" className="shrink-0">
    <circle cx="14" cy="12" r="9" fill="#EB001B" />
    <circle cx="22" cy="12" r="9" fill="#F79E1B" />
    <path d="M18 4.8a9 9 0 0 1 0 14.4 9 9 0 0 1 0-14.4z" fill="#FF5F00" />
  </svg>
);

export default function PaymentSecurity({ className = "", align = "center" }) {
  const alignCls = align === "center" ? "items-center text-center" : "items-start text-left";
  const rowCls = align === "center" ? "justify-center" : "justify-start";
  return (
    <div data-testid="payment-security" className={`flex flex-col ${alignCls} gap-3 ${className}`}>
      <div className={`flex items-center gap-3 ${rowCls}`}>
        <span className="inline-flex items-center gap-1.5 text-[#4A4A4A]">
          <Lock size={18} strokeWidth={2.5} />
          <span className="text-sm font-semibold">Säker betalning</span>
        </span>
        <span className="inline-flex items-center gap-2 bg-white border border-gray-200 rounded-md px-2 py-1">
          <VisaLogo />
        </span>
        <span className="inline-flex items-center gap-2 bg-white border border-gray-200 rounded-md px-2 py-1">
          <MastercardLogo />
        </span>
      </div>
      <p className="text-sm text-[#4A4A4A] leading-relaxed max-w-md">
        Transaktionen sker via krypterad förbindelse i samarbete med Stripe. Inga betalningsuppgifter lagras hos oss.
      </p>
    </div>
  );
}
